module.exports = __webpack_public_path__ + "static/media/image-9.a7e1e98a.jpg";